import { render } from "./AdminAuthHistory.vue?vue&type=template&id=45fbe606&scoped=true"
import script from "./AdminAuthHistory.vue?vue&type=script&lang=js"
export * from "./AdminAuthHistory.vue?vue&type=script&lang=js"

import "./AdminAuthHistory.vue?vue&type=style&index=0&id=45fbe606&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45fbe606"]])

export default __exports__